import { Activity, Salad, Sparkles, Flower2, ArrowUpRight } from "lucide-react";
import { SERVICES, waLink } from "@/config/site";
import { Reveal, SectionHeading } from "@/components/Reveal";

const ICONS = { Activity, Salad, Sparkles, Flower2 };

export default function Services() {
  return (
    <section id="servizi" className="section-pad scroll-mt-20 bg-[#f3efea]" data-testid="services-section">
      <div className="container-x">
        <SectionHeading
          number="03"
          label="Servizi in parafarmacia"
          title="Molto più di una parafarmacia."
          sub="Servizi dedicati al benessere della persona, con la stessa cura che mettiamo nella selezione dei prodotti."
        />

        <div className="mt-12 grid gap-5 sm:grid-cols-2 sm:gap-6 lg:mt-16">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.id} delay={(i % 2) * 0.1}>
                <article data-testid={`service-card-${s.id}`} className="card card-hover flex h-full flex-col p-7 sm:p-9">
                  <div className="flex items-start justify-between">
                    <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#edf3ff]">
                      <Icon className="h-5 w-5 text-[#0050e0]" strokeWidth={1.8} />
                    </div>
                    <span className="font-display text-sm font-bold text-[#0050e0]/40">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="font-display mt-6 text-xl font-bold tracking-tight text-[#1c1d1f] sm:text-2xl">
                    {s.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-[#575a61] sm:text-base">{s.text}</p>
                  <a
                    href={waLink(s.message)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`service-${s.id}-cta`}
                    className="group mt-7 inline-flex items-center gap-1.5 text-sm font-bold text-[#0050e0] transition-colors hover:text-[#003fa8]"
                  >
                    Richiedi informazioni
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
